export default {
    path: '/collectionRecruitInfo',
    name: 'collectionRecruitInfo',
    component: () =>
        import ( /* webpackChunkName: "collectionRecruitInfo" */ "@/pages/collectionRecruitInfo/index.vue"),
    meta: {
        title: '招聘信息采集'
    },
}